<template>
  <svg :aria-label="ariaLabel" :class="iconSizeClass" :data-qa="dataQA" :aria-hidden="ariaHidden" role="img" data-name="Airtable" class="d-icon d-icon--airtable" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M10.927 4.211 3.473 7.295a.5.5 0 0 0 .007.926l7.484 2.967c.658.261 1.39.261 2.048 0l7.484-2.968a.5.5 0 0 0 .007-.925L13.05 4.211a2.777 2.777 0 0 0-2.123 0" fill="#FFBF00"/><path d="M12.652 12.81v7.413a.5.5 0 0 0 .684.465l8.34-3.237a.5.5 0 0 0 .315-.465V9.572a.5.5 0 0 0-.684-.464l-8.34 3.237a.5.5 0 0 0-.315.464" fill="#26B5F8"/><path d="M10.705 13.192 8.23 14.387l-.251.121-5.225 2.504c-.331.16-.754-.082-.754-.45V9.603c0-.133.068-.248.16-.335a.568.568 0 0 1 .126-.094.532.532 0 0 1 .455-.035l7.922 3.139c.403.16.435.724.042.914" fill="#ED3049"/><path d="M10.705 13.192 8.23 14.387 2.16 9.269a.567.567 0 0 1 .126-.095.532.532 0 0 1 .455-.035l7.922 3.139c.403.16.435.724.042.914" fill="currentColor" fill-opacity=".25"/></svg>
</template>

<script>
import { ICON_SIZE_MODIFIERS } from '@/src/constants';

export default {
  name: 'DtIconAirtable',

  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: [String, Number],
      default: 500,
      validator: (s) => Object.keys(ICON_SIZE_MODIFIERS).includes(String(s)),
    },

    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: undefined,
    },
  },

  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ['loaded'],

  computed: {
    iconSizeClass () {
      return ICON_SIZE_MODIFIERS[this.size];
    },

    ariaHidden () {
      return !this.ariaLabel ? 'true' : 'false';
    },

    dataQA () {
      return this.$attrs['data-qa'] ?? 'dt-icon';
    },
  },

  created () {
    this.$emit('loaded');
  },
};
</script>
